module.exports = {
	forceScope: 'art_crm',
	extends: [
		'/',
		'templates',
		'artCrm',
		'entity',
		'controller'
	],

	config: {
		usage: 'management',
		entityContext: 'address',
		exportGranted: true,
		assignTagsGranted: true,
	}
}